import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash-es/debounce';

import config from '../../config';
import api from '../api';

export default class SearchRelations extends React.Component {
  static initialState = { loading: false, error: null, relations: [] };
  static defaultSearchOptions = {
    includeInactive: false,
    types: [],
    crmTypes: [],
    take: 15,
  };
  requestId = 0;
  state = SearchRelations.initialState;
  mounted = false;

  reset(overrides) {
    this.setState({ ...SearchRelations.initialState, ...overrides });
  }

  searchRelations = (searchValue, requestId) => {
    const { searchOptions, omitRelations } = this.props;

    const endpoint = `${config.appUrls.api}/api/relation/names`;

    const params = {
      searchValue,
      ...SearchRelations.defaultSearchOptions,
      ...searchOptions,
    };

    return api.base.get(endpoint, { params }).then(
      ({ data }) => ({
        data: data.filter(x => !omitRelations.some(r => r && r.id === x.id)),
        requestId,
      }),
      error => ({
        error,
        requestId,
      }),
    );
  };

  fetch = debounce(() => {
    if (!this.mounted) {
      return;
    }
    const { onLoaded, searchValue } = this.props;
    this.requestId += 1;
    this.searchRelations(searchValue, this.requestId).then(
      ({ data: relations, requestId }) => {
        if (this.mounted && requestId === this.requestId) {
          onLoaded({ relations });
          this.setState({ loading: false, relations });
        }
      },
      ({ error, requestId }) => {
        if (this.mounted && requestId === this.requestId) {
          onLoaded({ error });
          this.setState({ loading: false, error });
        }
      },
    );
  }, 300);
  prepareFetch() {
    this.reset({ loading: true });
  }
  componentDidMount() {
    this.mounted = true;
    // this.prepareFetch();
    // this.fetch();
  }
  componentDidUpdate(prevProps) {
    const { searchValue, omitRelations } = this.props;
    if (prevProps.searchValue !== searchValue || prevProps.omitRelations !== omitRelations) {
      if (!searchValue || searchValue.length < 3) {
        this.reset({});
      } else {
        this.prepareFetch();
        this.fetch();
      }
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const { children } = this.props;
    return children(this.state);
  }

  static propTypes = {
    children: PropTypes.func.isRequired, // Render func { loading, error, relations }
    onLoaded: PropTypes.func,
    searchValue: PropTypes.string,
    searchOptions: PropTypes.shape({}),
    omitRelations: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })),
  };
  static defaultProps = {
    onLoaded: () => {},
    searchValue: '',
    searchOptions: {},
    omitRelations: [],
  };
}
